<script>
import { mapGetters } from "vuex"

export default {
    name: "Location",
    components: {},
    data() {
        return {
            isLoading: false,
        }
    },
    created() {
        document.body.classList.add("location-view")
        // this.fetchLocation(this.$route.params.locationId);
    },
    destroyed() {
        document.body.classList.remove("location-view")
    },
    computed: {
        ...mapGetters("sidebar", {
            location: "location",
        }),
    },
    watch: {
        "$route.params.locationId": function (id) {
            // this.fetchLocation(id);
        },
    },
    methods: {
        fetchLocation: function (id) {
            if (!id || id === this.location?.id) {
                return
            }

            this.isLoading = true

            return this.axios
                .get("/locations/" + id)
                .then((response) => {
                    let location = response.data.data.location
                    this.$store.commit("sidebar/setLocation", location)
                })
                .catch((error) => {
                    console.log(error)
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
    },
}
</script>

<template>
    <div class="location">
        <router-view></router-view>
    </div>
</template>
